@if(loading){<lib-spinner-overlay></lib-spinner-overlay>}

<lib-dba-mat-table tableNameId="roofarea" [data]="roofareaList" [columnsdef]="columnsdefMain" [importButton]="false"
    [pageSize]="20" [editButton]="permissionService.RoofareaSchreiben"
    [createButton]="permissionService.RoofareaSchreiben" [deleteButton]="permissionService.RoofareaLoeschen"
    [(selectedElement)]="selectedRoofarea" (openDialog2)="OpenDialog($event)" (deleteClicked)="deleteData($event)">

    <lib-dba-mat-table-select [filter]="debitorFilter" [label]="language.debitor | translationPipe"
        labelProperty="Name" [list]="debitorList" [(value)]="selectedDebitor" [translate]="false"
        (valueChange)="filterStandort()">
    </lib-dba-mat-table-select>

    <lib-dba-mat-table-select [filter]="standortFilter" [label]="language.Standort| translationPipe"
        labelProperty="Bezeichnung" [list]="standortfilteredList" [(value)]="selectedStandort" [translate]="false"
        (valueChange)="filterObjekte()">
    </lib-dba-mat-table-select>

    <lib-dba-mat-table-select [filter]="objektFilter" [label]="language.objekt | translationPipe"
        labelProperty="Bezeichnung" [list]="objektfilteredList" [(value)]="selectedObjekt" [translate]="false">
    </lib-dba-mat-table-select>
    
</lib-dba-mat-table>